import { render, staticRenderFns } from "./ClassHistory.vue?vue&type=template&id=ebd087bc"
import script from "./ClassHistory.vue?vue&type=script&lang=js"
export * from "./ClassHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports